import { Grid } from '@mui/material';
import { memo } from 'react';
import { AccordionEditDataControl as AccordionEditControlDataVM } from 'shell/view-models/edit-data-control';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
// import FlagValidationFiscalCode from 'shell/components/shared/flag';
import { FormikTouched, FormikErrors } from 'formik';

interface FormEditControlDataProps {
  values?: AccordionEditControlDataVM;
  errors?: FormikErrors<AccordionEditControlDataVM>;
  touched?: FormikTouched<AccordionEditControlDataVM>;
  onChange: (
    key: keyof AccordionEditControlDataVM,
    value: AccordionEditControlDataVM[keyof AccordionEditControlDataVM]
  ) => void;
}

const FormEditControlDataComponent = ({
  values,
  onChange,
  errors,
  touched,
}: FormEditControlDataProps): React.ReactElement => {
  // const handleFlagChange = useCallback(
  //   (event) => {
  //     onChange('flag', event.target.value);
  //   },
  //   [onChange]
  // );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data decorrenza"
          value={values?.dateValidity || null}
          onChange={(dataValue) => {
            onChange('dateValidity', dataValue || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateValidity"
              fullWidth
              error={touched?.dateValidity && Boolean(errors?.dateValidity)}
              helperText={errors?.dateValidity}
            />
          )}
        />
      </Grid>
      {/* <Grid item xs={12} md={4}>
        <FlagValidationFiscalCode
          value={values?.flag || ''}
          onChange={handleFlagChange}
          error={touched?.flag && Boolean(errors?.flag)}
        />
      </Grid> */}
    </Grid>
  );
};

FormEditControlDataComponent.displayName = 'Form Edit Control data component';

const FormEditControlData = memo(FormEditControlDataComponent);

export default FormEditControlData;
